import { Component, OnInit, Input, OnChanges } from '@angular/core';

// Imports Service:
import { AnalisisEntity } from 'src/app/services/servicio-analisis.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnChanges {

  @Input() public objectAnalisisEntity : AnalisisEntity = {
    identificacion : '',
    nombreCompletoAfiliado: '',
    fechaNacimiento: null,
    celular : '',
    telefono: ''
  };

  constructor() { }

  ngOnChanges() {
    this.getObjectAnalisisEntity();
  }

  public async getObjectAnalisisEntity() {
    try {
      await this.objectAnalisisEntity;
    } catch(exception) {
      console.log(exception);
    }
  }

}
